/* eslint-disable react/no-unescaped-entities */
import { useRef, useState } from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';
import dynamic from 'next/dynamic';
import { useSelector } from 'react-redux';
import {
  familyLifeSubNav,
  foodAndShoopingSubNav,
  guidesSubNav,
} from '../../../../utils/ronsTips';
import useMobileDetect from '../../../hooks/useMobileDetect';
import ScrollableWithArrows from '../../Common/ScrollableWithArrows';
import { FOR_YOU_RONS_TIPS_ROUTE } from '../../../../utils/routes';
import { checkIsAuthenticated } from '../../../../utils/authUtils';

const MdArrowDropDown = dynamic(() =>
  import('react-icons/md').then((mod) => mod.MdArrowDropDown)
);
const MdArrowDropUp = dynamic(() =>
  import('react-icons/md').then((mod) => mod.MdArrowDropUp)
);

// const peopleSubNav = [{
//   id: 1,
//   name: 'Inspired by you',
//   url: '/rons-tips/people/inspired-by-you'
// }]

const MenuContainer = ({
  label,
  subMenus,
  link,
  isHighlighted,
  isOpen,
  setIsOpen = () => {},
}) => {
  const ref = useRef(null);

  const router = useRouter();
  const { city, tag_filter = 'most_popular' } = router.query;
  const isMobile = useMobileDetect();
  return (
    <>
      <div
        onClick={() => {
          if (isMobile) setIsOpen(!isOpen);
        }}
        onPointerEnter={() => {
          if (!isMobile) setIsOpen(true);
        }}
        onPointerLeave={() => {
          if (!isMobile) setIsOpen(false);
        }}
        className='relative'
      >
        <div
          ref={ref}
          className='flex items-center rounded-none py-1 pr-1 text-black'
        >
          <Link href={link}>
            <button
              className='flex items-center rounded-none py-1 pr-1 text-black'
              role='button'
            >
              <span
                className={`${
                  isHighlighted
                    ? 'text-black underline decoration-[#000] decoration-[2px] underline-offset-4 lg:underline-offset-8'
                    : 'text-black'
                }  text-sm font-semibold  uppercase`}
              >
                {label}
              </span>
              {subMenus?.length ? (
                <>{isOpen ? <MdArrowDropUp /> : <MdArrowDropDown />}</>
              ) : null}
            </button>
          </Link>
        </div>

        {subMenus && isOpen ? (
          // <OutsideAlerter outsideClickHandler={setIsOpen}>

          <div className='absolute left-1 top-8 z-[10000] border bg-white'>
            {subMenus.map((item, index) => (
              <div className='px-3 py-1 hover:bg-gray-100' key={index}>
                <Link
                  href={`${item.url}?city=${city}&tag_filter=${tag_filter}`}
                  className='dropdown-item text-sm  font-semibold uppercase '
                >
                  {item.name}
                </Link>
              </div>
            ))}
          </div>
        ) : // </OutsideAlerter>
        null}
      </div>
    </>
  );
};

export default function RonsTipsSubNavBar() {
  const router = useRouter();
  const { city, tag_filter = 'most_popular' } = router?.query;

  const [isGuideOpen, setIsGuideOpen] = useState(false);
  const [isFoodAndShopOpen, setIsFoodAndShopOpen] = useState(false);
  const [isFamilyLifeOpen, setIsFamilyLifeOpen] = useState(false);
  const lang = useSelector(({ common }) => common?.language);

  return (
    <div className='relative border-b-[1px] border-border-mid bg-white md:flex md:justify-center'>
      <div className='responsive-width-margin relative flex h-[58px] items-center'>
        <ScrollableWithArrows
          hasDropdown={isGuideOpen || isFoodAndShopOpen || isFamilyLifeOpen}
        >
          {/* <div className='justify-stretch flex gap-8'> */}
          <MenuContainer
            label={lang?.common?.home}
            link={`${process.env.NEXT_PUBLIC_FRONTEND_URL}/rons-tips?city=${city}&tag_filter=${tag_filter}`}
            isHighlighted={router.pathname === '/rons-tips'}
          />
          <MenuContainer
            label={lang?.rons_tips?.guides}
            subMenus={guidesSubNav(lang)}
            link={`${process.env.NEXT_PUBLIC_FRONTEND_URL}/rons-tips/guides?city=${city}&tag_filter=${tag_filter}`}
            isHighlighted={router.pathname.includes('/rons-tips/guides')}
            setIsOpen={setIsGuideOpen}
            isOpen={isGuideOpen}
          />
          <MenuContainer
            label={lang?.rons_tips?.food_and_shopping}
            subMenus={foodAndShoopingSubNav(lang)}
            link={`${process.env.NEXT_PUBLIC_FRONTEND_URL}/rons-tips/food-shopping?city=${city}&tag_filter=${tag_filter}`}
            isHighlighted={router.pathname.includes('/rons-tips/food-shopping')}
            setIsOpen={setIsFoodAndShopOpen}
            isOpen={isFoodAndShopOpen}
          />
          <MenuContainer
            label={lang?.rons_tips?.familylife || 'Family Life'}
            subMenus={familyLifeSubNav(lang)}
            link={`${process.env.NEXT_PUBLIC_FRONTEND_URL}/rons-tips/family-life?city=${city}&tag_filter=${tag_filter}`}
            isHighlighted={router.pathname.includes('/rons-tips/family-life')}
            setIsOpen={setIsFamilyLifeOpen}
            isOpen={isFamilyLifeOpen}
          />
          <MenuContainer
            label={lang?.rons_tips?.people}
            // subMenus={peopleSubNav}
            link={`${process.env.NEXT_PUBLIC_FRONTEND_URL}/rons-tips/people?city=${city}&tag_filter=${tag_filter}`}
            isHighlighted={router.pathname === '/rons-tips/people'}
            // setIsOpen={setIsPeopleOpen}
            // isOpen={isPeopleOpen}
          />
          <MenuContainer
            label={lang?.rons_tips?.out_of_town}
            // subMenus={ronTipsSubmenus}
            link={`${process.env.NEXT_PUBLIC_FRONTEND_URL}/rons-tips/out-of-town?city=${city}&tag_filter=${tag_filter}`}
            isHighlighted={router.pathname === '/rons-tips/out-of-town'}
          />
          <MenuContainer
            label={lang?.rons_tips?.contest}
            link={`${process.env.NEXT_PUBLIC_FRONTEND_URL}/rons-tips/contest?city=${city}&tag_filter=${tag_filter}`}
            isHighlighted={router.pathname === '/rons-tips/contest'}
          />
          <MenuContainer
            label={lang?.market?.events}
            link={`${process.env.NEXT_PUBLIC_FRONTEND_URL}/market/events?city=${city}`}
            isHighlighted={router.pathname === '/market/events'}
          />
          <MenuContainer
            label={lang?.rons_tips?.newsletter_archive}
            link={`${process.env.NEXT_PUBLIC_FRONTEND_URL}/rons-tips/newsletter-archive?city=${city}`}
            isHighlighted={router.pathname === '/rons-tips/newsletter-archive'}
          />

          {checkIsAuthenticated() && <MenuContainer
            label={lang?.common?.for_you}
            link={FOR_YOU_RONS_TIPS_ROUTE(city)}
            isHighlighted={router.pathname === '/rons-tips/for-you'}
          />}

          {/* </div> */}
        </ScrollableWithArrows>
      </div>
    </div>
  );
}
